<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.56445 14.8799V16.5584C4.56445 17.663 5.45988 18.5584 6.56445 18.5584H12.001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.2129 5.44105L12.2129 12.3975" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.6985 10.7109L12.2115 13.2891L9.72461 10.7109" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 18.2857L16.7419 20L21 16" stroke="#59C656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
